import { useState } from 'react';
import { AiChatBot } from './AiChatBot';

export function FloatingAiButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setIsOpen(true)}
        style={{
          position: 'fixed',
          right: 16,
          bottom: 'calc(var(--bottom-nav-height) + var(--safe-area-bottom) + 16px)',
          width: 52,
          height: 52,
          borderRadius: '50%',
          background: 'var(--theme-primary)',
          border: '2px solid var(--theme-bg-elevated)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
          fontSize: 24,
          cursor: 'pointer',
          zIndex: 90,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.2s',
        }}
        title="AI-помощник"
      >
        🦊
      </button>

      {isOpen && <AiChatBot onClose={() => setIsOpen(false)} />}
    </>
  );
}
